export const APIDataMap = {
  'product.basicInformation': 'productBasicInformation',
  'product.id': 'productId',
  'product.media.photoGallery.edges[0].node': 'content',
  'product.media.photoGallery.edges': 'edges',
  'product.guestCount': 'guestCount',
};

export const SessionDataMap = {
  'cacheData.data.AriesReservation': 'isSession',
  'cacheData.data.AriesReservation.availabilityRequestVO.numChildrenPerRoom': 'totalChildren',
  locale: 'locale',
  'cacheData.data.AriesReservation.isACRS': 'isACRS',
};

export const OrderDataMap = {
  'productType.segments[0].product.basicInformation': 'productBasicInformation',
  guestCount: 'guestCount',
  quantity: 'quantity',
  basicInformation: 'basicInformation',
  'productType.segments[0].product.rate.name': 'rateType',
  'productType.segments[0].product.termsAndConditions.rules': 'rules',
  'basicInformation.id': 'id',
  'productType.segments[0].product.id': 'productId',
  'productType.segments[0].product.rateDetails[0].id': 'rateCode',
  'productType.segments[0].product.rateDetails[0].ratePlanCategory': 'ratePlanCategory',
  'property.basicInformation.isMarshaProperty': 'isMarshaProperty',
  'property.basicInformation.currency': 'propertyCurrency',
  'productType.segments[0].product.media.photoGallery.edges': 'edges',
};
